var _MidiFile_data, _MidiFile_pointer;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
export class MidiFile {
    /**
     * Midi file reader.
     *
     * @param {Uint8Array} data
     * @note Ints are big-endian.
     */
    constructor(data) {
        _MidiFile_data.set(this, null);
        _MidiFile_pointer.set(this, 0);
        __classPrivateFieldSet(this, _MidiFile_data, new DataView(data.buffer, data.byteOffset, data.byteLength), "f");
    }
    movePointer(bytes) {
        return __classPrivateFieldSet(this, _MidiFile_pointer, __classPrivateFieldGet(this, _MidiFile_pointer, "f") + bytes, "f");
    }
    /**
     * Read an integer chunk of `bytes` bytes.
     *
     * @param {Number} bytes
     *
     * @returns {any}
     */
    readInt(bytes) {
        var _a, _b;
        bytes = Math.min(bytes, __classPrivateFieldGet(this, _MidiFile_data, "f").byteLength - __classPrivateFieldGet(this, _MidiFile_pointer, "f"));
        if (bytes < 1)
            return -1;
        let value = 0;
        if (bytes > 1) {
            for (let i = 1; i <= (bytes - 1); i++) {
                value += __classPrivateFieldGet(this, _MidiFile_data, "f").getUint8(__classPrivateFieldGet(this, _MidiFile_pointer, "f")) * Math.pow(256, (bytes - i));
                __classPrivateFieldSet(this, _MidiFile_pointer, (_a = __classPrivateFieldGet(this, _MidiFile_pointer, "f"), _a++, _a), "f");
            }
        }
        value += __classPrivateFieldGet(this, _MidiFile_data, "f").getUint8(__classPrivateFieldGet(this, _MidiFile_pointer, "f"));
        __classPrivateFieldSet(this, _MidiFile_pointer, (_b = __classPrivateFieldGet(this, _MidiFile_pointer, "f"), _b++, _b), "f");
        return value;
    }
    readInts(bytes, count) {
        const data = [];
        for (let i = 0; i < count; i++) {
            data.push(this.readInt(bytes));
        }
        return data;
    }
    readStr(bytes) {
        let text = '';
        for (let char = 1; char <= bytes; char++)
            text += String.fromCharCode(this.readInt(1));
        return text;
    }
    /**
     * Read "Variable Length Value" int (defined by size byte)
     * @returns
     */
    readIntVLV() {
        let value = 0;
        if (__classPrivateFieldGet(this, _MidiFile_pointer, "f") >= __classPrivateFieldGet(this, _MidiFile_data, "f").byteLength)
            return -1;
        if (__classPrivateFieldGet(this, _MidiFile_data, "f").getUint8(__classPrivateFieldGet(this, _MidiFile_pointer, "f")) < 128) {
            return this.readInt(1);
        }
        let FirstBytes = [];
        while (__classPrivateFieldGet(this, _MidiFile_data, "f").getUint8(__classPrivateFieldGet(this, _MidiFile_pointer, "f")) >= 128) {
            FirstBytes.push(this.readInt(1) - 128);
        }
        for (let dt = 1; dt <= FirstBytes.length; dt++) {
            value += FirstBytes[FirstBytes.length - dt] * Math.pow(128, dt);
        }
        return value + this.readInt(1); // Add last byte
    }
}
_MidiFile_data = new WeakMap(), _MidiFile_pointer = new WeakMap();
